/**
 * @param eventName {string}
 */
module.exports = function triggerCustomGoogleAnalyticsEvent(eventName) {
    if ("dataLayer" in window && "push" in window.dataLayer && typeof window.dataLayer.push === "function") {
        window.dataLayer.push({event: eventName})
    }
}